<template>
  <div class="bright">
    <div class="img"></div>
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <span class="pointer" @click="toHome">首页</span>
          <span>>></span>
          <span>{{tab}}</span>
        </div>
      </div>

      <div class="tab">
        <div class="tab-nav">
          <ul>
            <li :class="tab==='计量'?'active':''" @click="change('计量')">计量</li>
            <li :class="tab==='标准'?'active':''" @click="change('标准')">标准</li>
            <li :class="tab==='检验检测'?'active':''" @click="change('检验检测')">检验检测</li>
            <li :class="tab==='认证认可'?'active':''" @click="change('认证认可')">认证认可</li>
            <li :class="tab==='典型示范'?'active':''" @click="change('典型示范')">典型示范</li>
          </ul>
        </div>
        <div class="tab-content">
          <div class="card" v-for="item in list" :key="item.id" v-show="tab===item.nqiType"  @click="detail(item.id)">
              <div>
                <img class="card-img" :src="fileUrl +　item.coverImage">
              </div>
              <div class="card-content">
                <div class="card-title">{{item.title}}</div>
                <div class="card-icon"></div>
              </div>
          </div>
        </div>
      </div>

      <div class="pagination-box">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :total="this.totalPage"
          :current-page="this.currentPage"
          @current-change="pageChange">
        </el-pagination>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      tab: '计量',
      currentPage: 1,
      totalPage: 9,
      fileUrl: 'http://172.172.1.100:90/dataapi/sys/common/static/'
    }
  },
  created () {
    this.tab = this.$route.query.tab
    this.fetchList()
  },
  methods: {
    toHome () {
      this.$router.push('/')
    },
    change (value) {
      this.tab = value
      this.currentPage = 1
      this.fetchList()
      this.$router.push('/bright?tab=' + value)
    },
    fetchList () {
      this.fetch('/dataapi/open/nqi/dataBright/list', {nqiType: this.tab, pageNo: this.currentPage, pageSize: 9}).then(res => {
        this.list = res.result.records
        this.totalPage = res.result.total
      })
    },
    detail (id) {
      // console.log(id)
      this.$router.push({ path: '/brightDetail',
        query: {
          id
        } });
    },
    pageChange (page) {
      this.currentPage = page
      this.fetchList()
    }
  }
}

</script>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
  padding-bottom: 80px;
}
.bright {
  background-image: url("../../assets/images/cgzt.png");

  .breadcrumb-box {
    margin-bottom: 24px;
    padding-top: 12px;

    .breadcrumb-body {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;

      span {
        margin-right: 7px;
      }
    }
  }
  .img{
    width: 100%;
    height: 320px;
    background-image: url("../../assets/images/ldcgzt.png");
    background-repeat:no-repeat;
    background-size: 100% 100%;
  }
  .tab{
    .tab-nav {
      ul {
        display: flex;
        list-style: none;
        text-align: center;
        li {
          background: rgba(0, 0, 0, 0.1);
          margin-right: 24px;
          cursor: pointer;
          width: 112px;
          height: 36px;
          line-height: 36px;
          padding: 0 16px;
          transition: all .3s;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          border-radius: 4px;
          color: rgba(0, 0, 0, 0.85);
          &:hover {
            background-color: @color-base;
            color: #ffffff;
          }
          &.active {
            background-color: @color-base;
            color: #ffffff;
          }
        }
      }
    }
    .tab-content{
      display: flex;
      flex-wrap: wrap;
      margin-top: 40px;
      .card{
        margin-right: 24px;
        margin-bottom: 48px;
        transition: all  .25s  ease-in;
        &:hover {
          cursor: pointer;
          transform:translateY(-10px);
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
          .card-content .card-title{
            color: #136BAE;
          }
          .card-content .card-icon{
            background: url("../../assets/images/jt.png") -20px -20px
            no-repeat;
          }
        }
        width: 402px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
        .card-img{
          width: 100%;
          height: 268px;
        }
        .card-content{
          width: 100%;
          display: flex;
          align-items: center;
          height: 76px;
          background: #FFFFFF;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
          .card-title{
            width: 320px;
            margin: 27px 58px 27px 24px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
          }
          .card-icon{
            width: 10px;
            height: 10px;
            background: url("../../assets/images/jtblack.png") -9px -9px
            no-repeat;
            margin-right: 17px;
          }
        }
      }
    }
  }
}

.pagination-box {
  text-align: center;
}
</style>

<style lang="less">
.body-content {
  .pagination-box {
    margin-top: 60px;
    .el-pagination {
      button {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
      }
    }
    .el-pager {
      .number {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        &.active {
          background-color: rgba(46, 92, 154, 1)!important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/bright/index.vue